export default __webpack_public_path__ + "static/media/consorcioLogo.12cda786.svg";